<div>
  <p>
    We’re building a beautiful tool to create & share maps. Subscribe to stay up to date with what’s
    new.
  </p>
  <!-- Begin Mailchimp Signup Form -->
  <div id="mc_embed_signup">
    <form
      action="https://turbomaps.us8.list-manage.com/subscribe/post?u=4193638e768f7d960a27f08c8&amp;id=110a9a8ed3&amp;f_id=006a5ee0f0"
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      class="validate"
      target="_blank"
      novalidate
    >
      <div id="mc_embed_signup_scroll">
        <div class="mc-field-group">
          <input
            type="email"
            placeholder="Your email"
            value=""
            name="EMAIL"
            class="required email"
            id="mce-EMAIL"
            required
          />
          <input
            type="submit"
            value="Subscribe"
            name="subscribe"
            id="mc-embedded-subscribe"
            class="button"
          />
        </div>
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
          <input type="text" name="b_4193638e768f7d960a27f08c8_110a9a8ed3" tabindex="-1" value="" />
        </div>
      </div>
    </form>
  </div>
</div>

<style>
  div {
    padding: 0 1rem;
    text-align: center;
  }
  p {
    max-width: 350px;
    margin: 0 auto;
    font-size: 16px;
    line-height: 1.4;
    color: var(--surface-text-subtle);
  }
  @media (min-width: 500px) {
    p {
      max-width: 425px;
      font-size: 18px;
    }
  }
  form {
    padding: 2rem 0 1rem;
    vertical-align: top;
  }
  input[type='email'] {
    line-height: 1;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: 0;
    border-radius: 4px;
    background: var(--surface-bg);
    color: var(--surface-text);
    border: 1px solid var(--surface-border);
    outline: 0;
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 0.75rem;
  }
  @media (min-width: 500px) {
    input[type='email'] {
      vertical-align: top;
      display: inline-block;
      width: 280px;
      font-size: 1.125rem;
    }
  }
  input[type='email']:focus {
    border-color: var(--surface-bg-interactive-focus);
  }
  input[type='submit'] {
    appearance: none;
    padding: calc(0.75rem - 0.5px) 1rem;
    margin-bottom: 0.5rem;
    vertical-align: top;
    font-size: 0.85rem;
    background: var(--surface-bg-interactive);
    border-radius: 4px;
    border: 0;
    color: #fff;
    font-weight: 600;
    outline: 0;
  }
  input[type='submit']:hover {
    background: var(--surface-bg-interactive-hover);
  }
  input[type='submit']:focus {
    background: var(--surface-bg-interactive-focus);
    box-shadow: 0 0 0 1px #fff inset;
  }
</style>
